export default class ShareEvents {
  /**
   * Creates a tracking instance that handles all share links
   *
   */
  constructor() {
    this.config = {
      selectors: {
        shareLinks: ".Tracking--share",
      },
      attributes: {
        platform: "data-tracking-platform",
      },
    };

    this._init();
  }

  /**
   * binds user events
   *
   * @private
   */
  _init() {
    [...document.querySelectorAll(this.config.selectors.shareLinks)].forEach(
      (link) => {
        link.addEventListener("click", () => {
          this._onClickOnShareLink(link);
        });
      }
    );
  }

  /**
   * handles click on share link
   *
   * @param {HTMLElement} shareLink
   * @private
   */
  _onClickOnShareLink(shareLink) {
    const platform = shareLink.getAttribute(this.config.attributes.platform);

    window.dataLayer.push({
      event: "Event",
      event_name: "click_on_share",
      click_on_share: {
        share_via: platform,
        pp_event_category: "share",
        pp_event_action: platform,
        pp_event_name: undefined,
      },
    });
  }
}
